<template>
  <div class="general-page">
    <h1>SMS Login</h1>

    <p>Select which of your accounts you wish to login to.</p>

    <p class="notice success live">
      <i class="icon-ok-circled greenicon" />
      Code accepted - please select your account.
    </p>

    <div
      v-if="loading"
      class="twobuttons"
    >
      <img
        src="/assets/images/loading.gif"
        style="width:200px;"
      >
    </div>

    <form
      v-for="user in $store.state.smsLoginUsers"
      v-else
      :key="user.id"
    >
      <a
        class="button"
        style="cursor:pointer;"
        @click="pickUser(user.id)"
      >{{ user.email }}</a>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import authComposable from "./AuthComposable.js";
import axios from '../../axios.js'
import { useRoute } from 'vue-router';

export default {
    setup() {
        const route = useRoute();
        const loading = ref(false);
        const code = ref(null);
        const errors = ref([]);
        const { resetCaptcha } = authComposable();

        const pickUser = (userId) => {
            loading.value = true;
            errors.value = [];

            let data = {
                user_id: userId,
            };

            if (!route.query.route) {
                errors.value = { general: ['Your session has timed out.'] };
                loading.value = false;
                return false;
            }

            axios({
                method: 'post',
                url: atob(route.query.route),
                data: data
            }).then(response => {
                if (!response.data.success) {
                    errors.value = response.data.errors;
                    loading.value = false;
                } else if (response.data.redirect) {
                    window.location = response.data.redirect;
                } else {
                    window.location = response.data.url;
                }
            }).catch(() => {
                errors.value = { general: ['Something went wrong; please try again later.'] };
                loading.value = false;
            }).finally(() => {
                resetCaptcha();
            });
        };

        return {
            loading,
            code,
            errors,
            pickUser
        };
    }
};
</script>
